module.exports = __webpack_public_path__ + "static/media/prmc-gray.e0c99275.png";